import { render, staticRenderFns } from "./ProfileInvitations.vue?vue&type=template&id=7fce78be&scoped=true"
import script from "./ProfileInvitations.vue?vue&type=script&lang=ts"
export * from "./ProfileInvitations.vue?vue&type=script&lang=ts"
import style0 from "./ProfileInvitations.vue?vue&type=style&index=0&id=7fce78be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce78be",
  null
  
)

export default component.exports